import { useMutation } from '@tanstack/react-query';
import { IImpersonationContext, IOperationResultNoValue, ImpersonationBroker } from '../../extViewmodels';
import { Website } from '../../extViewmodels/sdk/models/Website';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useCreateWebsiteMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Website) => void;
	onError?: (error: IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (params: { website: Website; impersonationContext?: IImpersonationContext }) => {
			return userSession.webServiceHelper.callAsync<Website>(
				ImpersonationBroker.composeApiUrl({ urlPath: `website`, impersonationContext: params.impersonationContext }),
				'POST',
				params.website
			);
		},
		onError,
		onSuccess,
	});
}
